var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 67.075,
    viewBox: "0 0 102 67.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auction_Icon",
    "data-name": "Auction Icon",
    transform: "translate(-723.55 -329.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hammer",
    transform: "translate(739.21 337.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(0 47.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M36.923,31.815H4.431A4.436,4.436,0,0,1,0,27.385V24.431A4.436,4.436,0,0,1,4.431,20H36.923a4.436,4.436,0,0,1,4.431,4.431v2.954A4.436,4.436,0,0,1,36.923,31.815ZM4.431,22.954a1.479,1.479,0,0,0-1.477,1.477v2.954a1.479,1.479,0,0,0,1.477,1.477H36.923A1.479,1.479,0,0,0,38.4,27.385V24.431a1.479,1.479,0,0,0-1.477-1.477Z",
    transform: "translate(0 -20)",
    fill: "#a2547a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(11.815 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(6.768 6.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M19.293,32.824a2.566,2.566,0,0,1-1.89-.744L7.035,21.712c-1.814-1.814.18-4.951.833-5.979a40.555,40.555,0,0,1,5.379-6.469,40.524,40.524,0,0,1,6.475-5.391c1.034-.659,4.174-2.653,5.987-.839L36.077,13.4c1.817,1.817-.183,4.96-.839,5.99a40.6,40.6,0,0,1-5.394,6.478,40.483,40.483,0,0,1-6.466,5.376,8.543,8.543,0,0,1-4.085,1.577Zm4.33-27.7c-.517.021-3.757,1.7-8.277,6.218s-6.2,7.763-6.1,8.5L19.494,29.992c.52-.021,3.76-1.7,8.283-6.221,4.348-4.351,6.067-7.515,6.1-8.4Z",
    transform: "translate(-6.291 -2.291)",
    fill: "#a2547a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(0 22.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M18.778,28.98a4.4,4.4,0,0,1-3.119-1.291L5.291,17.321a4.407,4.407,0,0,1,0-6.236L7.367,9.012a4.414,4.414,0,0,1,6.236,0L23.971,19.38a4.414,4.414,0,0,1,0,6.236L21.9,27.689a4.407,4.407,0,0,1-3.119,1.291ZM10.484,10.675a1.464,1.464,0,0,0-1.031.428L7.382,13.174a1.455,1.455,0,0,0,0,2.062L17.75,25.6a1.461,1.461,0,0,0,2.059,0l2.074-2.074a1.458,1.458,0,0,0,0-2.059L11.515,11.1a1.464,1.464,0,0,0-1.031-.428Z",
    transform: "translate(-4 -7.722)",
    fill: "#a2547a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(22.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M26.5,21.255a4.4,4.4,0,0,1-3.119-1.291L13.012,9.6a4.411,4.411,0,0,1,0-6.233L15.085,1.29a4.414,4.414,0,0,1,6.236,0L31.689,11.658a4.414,4.414,0,0,1,0,6.236l-2.074,2.074A4.392,4.392,0,0,1,26.5,21.255ZM18.2,2.956a1.461,1.461,0,0,0-1.031.425L15.1,5.455a1.455,1.455,0,0,0,0,2.056L25.468,17.879a1.464,1.464,0,0,0,2.059,0L29.6,15.808a1.458,1.458,0,0,0,0-2.059L19.233,3.381A1.449,1.449,0,0,0,18.2,2.956ZM30.643,16.851h.03Z",
    transform: "translate(-11.722 -0.001)",
    fill: "#a2547a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(25.909 25.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M40.319,41.951c-1.781,0-3.7-1.019-5.736-3.057s-14.022-15.227-21.46-24a1.477,1.477,0,0,1,2.254-1.908c7.757,9.145,19.534,22.057,21.294,23.817,3.326,3.332,4.623,2.035,5.4,1.267a2.593,2.593,0,0,0,.91-1.533c.1-1.007-.653-2.342-2.174-3.867-1.746-1.749-14.636-13.508-23.817-21.3A1.476,1.476,0,1,1,18.9,9.122c8.805,7.47,21.98,19.439,24,21.463,2.2,2.2,3.22,4.3,3.025,6.247a5.4,5.4,0,0,1-1.761,3.326,5.4,5.4,0,0,1-3.843,1.793Z",
    transform: "translate(-12.771 -8.77)",
    fill: "#a2547a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(724 329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M50.806,17.642c25.768,0,42.509-33.706,42.509-7.938A46.657,46.657,0,0,1,0,9.7C0-16.065,25.038,17.642,50.806,17.642Z",
    transform: "translate(3.892 10.788)",
    fill: "#a2547a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 5.5,
    cy: 5,
    rx: 5.5,
    ry: 5,
    transform: "translate(30.55 0.074)",
    fill: "#a2547a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(68.55 7.074)",
    fill: "#a2547a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(25.55 10.074)",
    fill: "#a2547a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 5.5,
    cy: 5,
    rx: 5.5,
    ry: 5,
    transform: "translate(90.55 56.074)",
    fill: "#a2547a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 5.5,
    cy: 5,
    rx: 5.5,
    ry: 5,
    transform: "translate(-0.45 57.074)",
    fill: "#a2547a",
    opacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionIcon);
export default __webpack_public_path__ + "static/media/Auction-Icon.c9bc53ec7502f102d6432ff3b8d32e44.svg";
export { ForwardRef as ReactComponent };